const baseURL = process.env.REACT_APP_BASE_URL + 'ies/';

export async function list_ies(token) {
  const data = new FormData();
  data.append('token', token);
  return loadJson(data, 'list_ies');
}

export async function load_ie(token, id) {
  const data = new FormData();
  data.append('token', token);
  data.append('id', id);
  return loadJson(data, 'load_ie');
}

export async function update_ie(
  token,
  {
    id = 0,
    name,
    country,
    city,
    departamento,
    zona,
    sede,
    lat,
    lon,
    official_code,
    geo_source,
    geo_precision_m,
  }
) {
  const data = new FormData();
  data.append('token', token);
  data.append('id', id || 0);
  data.append('name', name ?? '');
  data.append('country', country ?? '');
  data.append('city', city ?? '');
  data.append('departamento', departamento ?? '');
  data.append('zona', zona ?? '');
  data.append('sede', sede ?? '');
  data.append('lat', lat ?? '');
  data.append('lon', lon ?? '');
  data.append('official_code', official_code ?? '');
  data.append('geo_source', geo_source ?? '');
  // Cadena vacía = "sin declarar"; el PHP la traduce a NULL.
  data.append(
    'geo_precision_m',
    geo_precision_m === null || geo_precision_m === undefined ? '' : String(geo_precision_m)
  );
  return loadJson(data, 'update_ie');
}

export async function delete_ie(token, id) {
  const data = new FormData();
  data.append('token', token);
  data.append('id', id);
  return loadJson(data, 'delete_ie');
}

export async function load_ie_trainers(token, ies_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('ies_id', ies_id);
  return loadJson(data, 'load_ie_trainers');
}

export async function add_ie_trainer(token, ies_id, email_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('ies_id', ies_id);
  data.append('email_id', email_id);
  return loadJson(data, 'add_ie_trainer');
}

export async function remove_ie_trainer(token, link_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('link_id', link_id);
  return loadJson(data, 'remove_ie_trainer');
}

export async function set_serial_ies(token, project_id, serials, ies_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('project_id', project_id);
  data.append('serials', JSON.stringify(serials || []));
  data.append('ies_id', ies_id ?? 0);
  return loadJson(data, 'set_serial_ies');
}

export async function set_pin_ies(token, project_id, pins, ies_id) {
  const data = new FormData();
  data.append('token', token);
  data.append('project_id', project_id);
  data.append('pins', JSON.stringify(pins || []));
  data.append('ies_id', ies_id ?? 0);
  return loadJson(data, 'set_pin_ies');
}

async function loadJson(data, url) {
  try {
    const response = await fetch(baseURL + url + '.php', {
      method: 'POST',
      body: data,
    });
    const resp = await response.text();

    if (resp !== 'INVALID') {
      try {
        return JSON.parse(resp);
      } catch (err) {
        return resp;
      }
    }
    return 'INVALID';
  } catch (error) {
    console.error('Error:' + error);
    return null;
  }
}
